export class BirthdayCampaign {
    constructor(birthdayCampaign) {
        this.content     = birthdayCampaign.content;
        this.before_date = birthdayCampaign.before_date;
    }
}